import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "justify-center items-center font-pt-root" }
const _hoisted_3 = { class: "ml-0" }
const _hoisted_4 = { class: "sm:flex" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "text-left font-londrina text-4xl" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("<")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(">")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "text-left font-bold" }
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "font-londrina text-4xl mt-6" }
const _hoisted_18 = { class: "text-left ml-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Languages = _resolveComponent("Languages")!
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["sm:w-1/2 w-full", _ctx.bgColor])
          }, [
            _createElementVNode("a", {
              href: `${_ctx.openseaUrl}/assets/${_ctx.contractAddress}/${_ctx.nounId}`,
              target: "_blank"
            }, [
              _createElementVNode("img", {
                src: _ctx.nfts[_ctx.nounId]?.data?.image,
                class: "w-full"
              }, null, 8, _hoisted_6)
            ], 8, _hoisted_5)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-1 flex-col sm:w-1/2 w-full pb-4 px-4 pt-6", _ctx.bgColor])
          }, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.prevNounId)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: _ctx.localizedUrl('/noun/' + _ctx.prevNounId)
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.nfts[_ctx.nounId]?.data?.name || "Loading...") + " ", 1),
              (_ctx.nextNounId)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: _ctx.localizedUrl('/noun/' + _ctx.nextNounId)
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
              _hoisted_10
            ]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.nfts[_ctx.nounId]?.data?.description || "Loading..."), 1),
            _createElementVNode("div", _hoisted_12, [
              _createTextVNode(_toDisplayString(_ctx.$t("heldBy")) + " ", 1),
              (_ctx.nfts[_ctx.nounId]?.owner)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                    _createElementVNode("a", {
                      href: `${_ctx.openseaUrl}/${_ctx.nfts[_ctx.nounId]?.owner}`,
                      target: "_blank"
                    }, [
                      _createTextVNode(_toDisplayString((_ctx.nfts[_ctx.nounId]?.owner).substr(0, 10)), 1),
                      _hoisted_15
                    ], 8, _hoisted_14)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, " Loading... "))
            ])
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("aboutNounsLove")), 1)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_Languages)
    ]),
    _createVNode(_component_Message)
  ]))
}